<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="heading_id_2"><a id="page_v"></a><a id="contents"></a><em><strong>Contents</strong></em></h2>
<p class="tocchap"><a class="nounder" href="#/Text/halftitle2#halftitle">After Fukushima: The Equivalence of Catastrophes</a></p>
<p class="tocchap1"><a class="nounder" href="#/Text/preamble#preamble">Preamble</a></p>
<p class="tocchap1"><span class="nounder" href="#/Text/ch01#ch01" title="Link target outside of Sample"> 1</span></p>
<p class="tocchap1"><span class="nounder" href="#/Text/ch02#ch02" title="Link target outside of Sample"> 2</span></p>
<p class="tocchap1"><span class="nounder" href="#/Text/ch03#ch03" title="Link target outside of Sample"> 3</span></p>
<p class="tocchap1"><span class="nounder" href="#/Text/ch04#ch04" title="Link target outside of Sample"> 4</span></p>
<p class="tocchap1"><span class="nounder" href="#/Text/ch05#ch05" title="Link target outside of Sample"> 5</span></p>
<p class="tocchap1"><span class="nounder" href="#/Text/ch06#ch06" title="Link target outside of Sample"> 6</span></p>
<p class="tocchap1"><span class="nounder" href="#/Text/ch07#ch07" title="Link target outside of Sample"> 7</span></p>
<p class="tocchap1"><span class="nounder" href="#/Text/ch08#ch08" title="Link target outside of Sample"> 8</span></p>
<p class="tocchap1"><span class="nounder" href="#/Text/ch09#ch09" title="Link target outside of Sample"> 9</span></p>
<p class="tocchap1"><span class="nounder" href="#/Text/ch10#ch10" title="Link target outside of Sample">10</span></p>
<p class="tocchap2"><span class="nounder" href="#/Text/question#question" title="Link target outside of Sample">Questions for Jean-Luc Nancy</span></p>
<p class="tocchap1">Yuji Nishiyama and Yotetsu Tonaki</p>
<p class="tocchapa"><span class="nounder" href="#/Text/catastro#catastro" title="Link target outside of Sample">It’s a Catastrophe! Interview with Jean-Luc Nancy</span></p>
<p class="tocchap1">Danielle Cohen-Levinas</p>
<p class="tocchap2"><em><span class="nounder" href="#/Text/notes#notes" title="Link target outside of Sample">Notes</span></em><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3ecaaeda